var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { StyledTable, BlockLayout } from "./styled";
var tableRenderOptions = {
    mainContainer: {
        block: function (_a) {
            var children = _a.children, className = _a.className, callbackRef = _a.callbackRef, props = __rest(_a, ["children", "className", "callbackRef"]);
            return (React.createElement(BlockLayout, __assign({ ref: callbackRef, className: "table-container ".concat(className || "") }, props), children));
        },
        table: function (_a) {
            var children = _a.children, callbackRef = _a.callbackRef, props = __rest(_a, ["children", "callbackRef"]);
            return (React.createElement(StyledTable, __assign({ ref: callbackRef }, props), children));
        },
    },
    tbody: {
        block: function (_a) {
            var children = _a.children, props = __rest(_a, ["children"]);
            return (React.createElement("div", __assign({ className: "table-body" }, props), children));
        },
        table: function (_a) {
            var children = _a.children, props = __rest(_a, ["children"]);
            return React.createElement("tbody", __assign({}, props), children);
        },
    },
};
export var TableContainer = function (_a) {
    var children = _a.children, layoutType = _a.layoutType, props = __rest(_a, ["children", "layoutType"]);
    var renderTableContainer = tableRenderOptions.mainContainer[layoutType];
    return renderTableContainer(__assign({ children: children }, props));
};
export var TableBody = function (_a) {
    var children = _a.children, layoutType = _a.layoutType, props = __rest(_a, ["children", "layoutType"]);
    var renderTableBody = tableRenderOptions.tbody[layoutType];
    return renderTableBody(__assign({ children: children }, props));
};
